/**
 * Language pill UK / EN of the side panel and the sign-in screens.
 * Adding a new locale requires nothing here; the buttons are derived
 * from `LOCALES` in `i18n/messages.ts`.
 */
import { useLocale } from '../i18n/locale-context.js';
import { LOCALES, LOCALE_LABEL } from '../i18n/messages.js';

export function LanguageSwitcher({ className = '' }: { className?: string }) {
  const { locale, setLocale, t } = useLocale();
  return (
    <fieldset className={`lang ${className}`.trim()} aria-label={t('nav.lang')}>
      {LOCALES.map((l) => (
        <button key={l} type="button" aria-pressed={locale === l} onClick={() => setLocale(l)}>
          {LOCALE_LABEL[l]}
        </button>
      ))}
    </fieldset>
  );
}
